import * as React from 'react';
import { ChartData } from 'src/components/HomePage/AnalyticsSection/Chart';
import BaseTypography from 'src/components/Text/BaseTypography';

// Note: We were doing a rounding to the nearest multiple of 5
// here that made the data display incorrectly. See this PR
// https://github.com/copilot-platforms/copilot/pull/3209/
export function YAxisLabel({ data }: { data: ChartData[] }) {
  const min = React.useMemo(
    () => Math.min(...data.map((item) => item.total)),
    [data],
  );
  const max = React.useMemo(
    () => Math.max(...data.map((item) => item.total)),
    [data],
  );
  // The logic here is a little arbitrary. But when we have very
  // low counts, the rounded midpoint is often not helpful. For
  // example, if the total is 1 the rounded midpoint would be 1.
  const mid = max > 10 ? Math.round((min + max) / 2) : (min + max) / 2;

  const labels = [max, mid, min];
  const getPositionClassname = (idx: number) => {
    // positions the labels at the top, middle, and bottom of the chart
    if (idx === 0) return 'top-0 translate-y-[-50%]';
    if (idx === 1) return 'top-1/2 translate-y-[-50%]';
    if (idx === 2) return 'bottom-0 translate-y-[50%]';
    return '';
  };

  return (
    <div className="relative w-full h-full text-gray-500">
      {labels.map((label, index) => (
        <div key={index} className={`absolute ${getPositionClassname(index)}`}>
          <BaseTypography fontType="12Regular" className="text-right">
            {label}
          </BaseTypography>
        </div>
      ))}
    </div>
  );
}
